import React, { useCallback, useEffect } from 'react';
import { array, bool, func, shape } from 'prop-types';

import { groupBy } from 'lodash';

import useApi from '../../hooks/useApi';
import template from 'url-template';
import lambdaBaseApi from '../../apis/lambda';

import TagSelect from '../../components/FormFields/TagSelect';

const StatusesUrl = template.parse('/servicecalls/statuses');

const CallStatusesFilter = ({
    disabled,
    callStatusesFilter,
    onChangeCallStatusesFilter,
    ...props
}) => {
    const [callStatuses, getCallStatuses] = useApi(() => ({
        url: StatusesUrl.expand()
    }), lambdaBaseApi);

    useEffect(() => {
        getCallStatuses();

        return () => {
            callStatuses.cancel();
        };
    }, []);

    const changeHandler = (defaultValues = {}) => {
        return (event) => {
            const { value } = event.target;
            const groupedValues = groupBy(value, 'type');
            const newValues = { ...defaultValues };
            Object.entries(groupedValues).forEach(([type, value]) => {
                newValues[type] = value;
            });
            onChangeCallStatusesFilter(newValues);
        };
    };

    const handleChange = useCallback(
        changeHandler({
            callStatuses: []
        })
    );

    const options = [
        {
            error:     callStatuses.error,
            isLoading: callStatuses.loading,
            items:     callStatuses.data,
            name:      'Call Statuses',
            itemProps: {
                type: 'callStatuses'
            }
        }
    ];

    const value = [...callStatusesFilter.callStatuses];

    return (
        <TagSelect
            disabled={disabled}
            grouped
            kickerText="Add any combination of Call Statuses to filter by these items."
            label="Call Statuses"
            name={undefined}
            onChange={handleChange}
            options={options}
            placeholder="Add Call Status"
            value={value}
            {...props}
        />
    );
};

CallStatusesFilter.defaultProps = {
    callStatusesFilter: {
        callStatuses: []
    },
    disabled:                   false,
    onChangeCallStatusesFilter: () => {}
};

CallStatusesFilter.propTypes = {
    callStatusesFilter: shape({
        callStatuses: array.isRequired
    }),
    disabled:                   bool,
    onChangeCallStatusesFilter: func.isRequired
};

export default CallStatusesFilter;
